// extracted by mini-css-extract-plugin
export var subtitle = "_cp-2";
export var title = "_cp-0";
export var titleNoWrap = "_cp-1";